import { Text } from "@/elements"
import { Color, getHex } from "@/theme"
import clsx from "clsx"

import type { JSX } from "react";

type ChipSize = "small" | "medium" | "large"

export const Chip = ({
  text,
  onClick,
  size = "medium",
  bgColor = "bg-2",
  textColor = "fg-1",
  rightIcon,
  leftIcon,
}: {
  text: string
  onClick?: () => void
  size?: ChipSize
  bgColor?: Color
  textColor?: Color
  rightIcon?: JSX.Element
  leftIcon?: JSX.Element
}) => {
  const hexBgColor = getHex(bgColor)
  const hexTextColor = getHex(textColor)

  return (
    <div
      style={{
        backgroundColor: hexBgColor,
        color: hexTextColor,
      }}
      className={clsx("flex shrink-0 snap-start flex-row items-center justify-center gap-x-2 rounded-full", {
        "h-[51px] px-[20px] py-3": size === "medium",
        "h-[40px] px-[16px]": size === "small",
        "pr-[9px]": !!rightIcon,
      })}
      onClick={onClick}>
      {!!leftIcon && leftIcon}
      <Text variant="body1">{text}</Text>
      {!!rightIcon && rightIcon}
    </div>
  )
}
